const NAME = 'AbortError';

interface ErrorWithNetworkError {
  networkError?: Error;
}

export class AbortError extends Error {
  constructor(message: string = 'Aborted') {
    super(message);
    this.name = NAME;
    this.message = message;
  }
}

const hasNetworkAbortError = (error: Error): boolean => {
  const errorObj = error as ErrorWithNetworkError;
  return errorObj?.networkError?.name === NAME;
};
const looksLikeAbortError = (error: Error): boolean => error?.message?.includes('aborted');

export const isAbortError = (error: Error): boolean =>
  error instanceof AbortError ||
  error?.name === NAME ||
  hasNetworkAbortError(error) ||
  looksLikeAbortError(error);
